<template>
    <div class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-33">
        <md-card class="dashboard-platform" :class="cardClasses" @click.native="actionRedirect">
            <div>
                <img src="../../assets/images/circlehead.png"> {{name}}
            </div>

            <small v-if="!hasAccess" @click="actionShowModal">{{$t('Do you have an account to pair?')}}</small>
        </md-card>
        <account-pair-modal :show-modal="showModal"/>
    </div>
</template>

<script>
    import AccountPairModal from "../modals/AccountPairModal";
    import {mapGetters} from "vuex";
    import UrlMap from "../../js/slug-to-url-map";

    export default {
        name: "DashboardPlatform",
        components: {AccountPairModal},
        props: {
            data: {
                type: Object,
                required: true,
            }
        },
        computed: {
            name() {
                return this.data.name ?? '';
            },
            slug() {
                return this.data.slug ?? '';
            },
            redirectHost() {
                return UrlMap[this.slug] ?? '';
            },
            user() {
                return this.authenticatedInitData.user ?? {};
            },
            appAccesses() {
                return this.user.accesses ?? [];
            },
            hasAccess() {
                let appAccesses = this.appAccesses.find(appAccess => {
                    return appAccess.appSlug === this.slug;
                }) ?? {};

                return appAccesses.hasAccess ?? false;
            },
            isActive() {
                let appAccesses = this.appAccesses.find(appAccess => {
                    return appAccess.appSlug === this.slug;
                }) ?? {};

                return appAccesses.isActive ?? false;
            },
            cardClasses() {
                return {
                    'disabled': !this.hasAccess || !this.isActive,
                }
            },
            ...mapGetters('app', {
                authenticatedInitData: 'getAuthenticatedInitData',
            })
        },
        data() {
            return {
                showModal: false,
            }
        },
        methods: {
            actionShowModal() {
                this.showModal = true;
            },
            actionRedirect() {
                if (this.hasAccess && this.isActive) {
                    window.location.href = this.redirectHost;
                }
            }
        }
    }
</script>

<style lang="scss">
    .dashboard-platform {
        padding: 28px !important;
        cursor: pointer;
        background-image: url("../../assets/images/platform-tile-bg.jpg") !important;
        background-repeat: repeat-x !important;
        background-position: top center !important;

        div {
            font-weight: 700 !important;
            font-size: 14px !important;
        }

        img {
            height: 48px !important;
            width: 48px !important;
            margin-right: 12px;
        }

        small {
            position: absolute;
            top: calc(100% + 12px);
            left: 50%;
            transform: translateX(-50%);
            text-align: center;
            cursor: pointer;

            &:hover {
                text-decoration: underline;
            }
        }

        &.disabled {
            cursor: default;
            background-image: url("../../assets/images/platform-tile-bg-disabled.jpg") !important;

            img {
                filter: grayscale(100%);
            }
        }
    }
</style>